import React from 'react';
import moment from 'moment-timezone';
import {isEmpty as _isEmpty} from 'lodash';

import Chip from '@ui/Chip';
import {DATETIME_FORMAT, TIME_FORMAT} from '@utils/date';
export const buildEventTimeDisplayFragments = (
    row,
    {
        timezone = null,
        rangeBetweenStartAndEnd = 'liveControlBreaks',
        keyPrefix = 'evtTime',
    } = {}
) => {
    if (!row.event_content_start_datetime) {
        return [];
    }

    const liveControlKeys = 'ecsd' === keyPrefix;
    const keyStart = liveControlKeys ? `ecsd_st${row.id}` : `${keyPrefix}_st_${row.id}`;
    const keySep = liveControlKeys ? `ecsd_sep${row.id}` : `${keyPrefix}_sep_${row.id}`;
    const keyEnd = liveControlKeys ? `ecsd_et${row.id}` : `${keyPrefix}_end_${row.id}`;

    const now = timezone ? moment().tz(timezone) : moment();
    const parseInZone = (v) => (timezone ? moment.tz(v, timezone) : moment(v));

    let startDatetimeFormat = TIME_FORMAT;
    const start = parseInZone(row.event_content_start_datetime);

    if (!start.isSame(now, 'day')) {
        startDatetimeFormat = DATETIME_FORMAT;
    }

    const fragments = [
        <span key={keyStart}>
            {start.format(startDatetimeFormat)}
        </span>,
    ];

    if (!_isEmpty(row.event_content_end_datetime)) {
        let endDatetimeFormat = TIME_FORMAT;
        const end = parseInZone(row.event_content_end_datetime);

        if (!end.isSame(now, 'day')) {
            endDatetimeFormat = DATETIME_FORMAT;
        }

        fragments.push('liveControlBreaks' === rangeBetweenStartAndEnd
            ? <span key={keySep}><br />-<br /></span>
            : <span key={keySep}> - </span>);
        fragments.push(
            <span key={keyEnd}>
                {end.format(endDatetimeFormat)}
            </span>
        );
    }

    if (row.event_content_is_247_stream) {
        fragments.push(
            <div key={`ec247_${row.id}`}>
                <Chip
                    sx={{
                        background: '#767676',
                        borderColor: '#767676',
                        color: '#fff',
                    }}
                    size='small'
                    label='24/7' />
            </div>);
    }

    return fragments;
};
